/**
 * TODO: [HALO-MIGRATION] Delete this entire file and folder after migration is complete
 */
import { AppBar, Typography, Button } from '@mui/material';

const HALO_CREATOR_CENTER_URL = 'https://creator.fashionnova.com';

function HaloMigrationBanner() {
  return (
    <AppBar
      position="static"
      color="default"
      className="bg-black flex flex-row items-center justify-center w-full min-h-[40px] py-2 gap-4"
    >
      <Typography className="text-sm font-normal leading-[16px] text-white">
        Your account has moved to our new Creator Center
      </Typography>
      <Button
        variant="outlined"
        size="small"
        href={HALO_CREATOR_CENTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-black bg-white border-white hover:bg-gray-100 hover:border-gray-100 text-xs px-4 py-1 min-w-0 normal-case"
      >
        Visit
      </Button>
    </AppBar>
  );
}

export default HaloMigrationBanner;
